<template>
  <div class="component-breadcrumbs">
    <component
      v-for="(route, i) in breadcrumbs"
      class="breadcrumb-route"
      :is="route.name && i + 1 < breadcrumbs.length ? 'router-link' : 'span'"
      :key="i"
      :to="{ name: route.name, params: route.params }"
    >
      <span>
        {{ route.title }}
      </span>
      <span class="px-3" v-if="i + 1 !== breadcrumbs.length">
        /
      </span>
    </component>
  </div>
</template>
<script>
import BreadcrumbsMixin from "@/mixins/breadcrumbs";
export default {
  mixins: [BreadcrumbsMixin]
};
</script>
<style lang="scss" scoped>
.component-breadcrumbs {
  display: flex;
  flex-wrap: wrap;

  span {
    color: var(--dark-100);
  }
  a {
    color: var(--dark-40);
    transition: color 0.1s;

    &:hover {
      color: var(--dark-100);
      text-decoration: none;

      .divider {
        color: var(--dark-40);
      }
    }
  }

  .breadcrumb-route {
    display: flex;

    font-size: 14px;
    font-weight: 400;
    line-height: 24px;
  }

  @media screen and (max-width: 767px) {
    .breadcrumb-route {
      gap: 4px;
      .divider {
        width: 20px;
        font-size: 12px;
        line-height: 20px;
      }
    }
  }
}
</style>
